module.exports = __webpack_public_path__ + "static/media/grand-tour-bg.5b92b891.png";